<template>
  <div class="f14-l19 h-100 d-flex" :class="alignment">
    <div class="d-flex flex-row align-items-center" :class="alignment">
      <div v-if="availability.availability_popup" class="align-items-center d-flex flex-row position-relative small-space">
        <img src="@/assets/calendar-icon.svg" style="height: 14px;" class="spacer-left-small pointer" @click="showTimes" />
        <div class="accordion-header pointer" @click="showTimes">{{availability.availability_popup.title}}</div>
        <CaretComponent :open="timesVisible" @click="showTimes" />
        <div v-show="timesVisible">
          <div class="d-flex flex-column innerpopup ">
            <div class="bold" style="border-bottom: 1px solid #ccc; padding-bottom: 10px;">{{availability.availability_popup.list.title}}</div>
            <div class="d-flex flex-row" v-for="(item,idx) in availability.availability_popup.list.data" :key="idx" style="padding:5px 0;width: 200px;">
              <div class="flex-grow-1">{{item.title}}</div>
              <div class="flex-grow-1 text-start" v-html="item.range"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="availability.cities_popup" class="align-items-center d-flex flex-row position-relative small-space">
        <img v-if="availability.cities_popup.icon" :src="availability.cities_popup.icon" style="height: 14px;" class="spacer-left-small pointer" @click="showTimes" />
        <div class="accordion-header pointer" @click="showCities">{{availability.cities_popup.title}}</div>
        <CaretComponent :open="timesVisible" @click="showCities" />
        <div v-show="timesVisible">
          <div class="d-flex flex-column innerpopup cities_popup " ref="popup" dir="rtl">
            <div class="d-flex flex-column text-center" v-for="(item,idx) in availability.cities_popup.list" :key="idx" style="padding:5px 0;width: auto;">
              <div class="bold flex-row " >{{item.region_title}}</div>
              <div class="flex-row " v-html="item.region_cities"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="availability.availability_line" class="avail_alignment">
        <div @click="showTimes" class="align-items-center d-flex pointer">{{availability.availability_line}}</div>
      </div>
    </div>
    <BGClickCatcherComponent v-show="timesVisible" @click="showTimes" />
  </div>
</template>
<script>
import CaretComponent from "@/components/CaretComponent";
import BGClickCatcherComponent from "@/components/popup/BGClickCatcherComponent";
export default {
  components: {
    CaretComponent,
    BGClickCatcherComponent
  },
  data() {
    return {
      timesVisible: false,
      showit: false
    }
  },
  props: {
    availability: Object,
    alignRight: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showTimes() {
      this.timesVisible = !this.timesVisible;
    },
    showCities() {
      this.timesVisible = !this.timesVisible;
      if (this.timesVisible) {
        this.$nextTick(() => {
          this.adjustPopupPosition(); // Adjust position after it opens
        });
      }
    },
    openSelectCity() {
      if ("select_city_popup" == this.availability?.on_click) {
        this.$store.dispatch('showSelectCity');
      }
    },
    adjustPopupPosition() {
      const popup = this.$refs.popup;
      if (popup) {
        const rect = popup.getBoundingClientRect();
        const viewportWidth = window.innerWidth;

        // Adjust right overflow
        if (rect.right > viewportWidth) {
          popup.style.right = '10px';
          popup.style.left = 'auto';
        } else {
          popup.style.right = '0';
          popup.style.left = 'auto';
        }


        // Adjust left overflow
        if (rect.left < 0) {
          popup.style.left = '10px';
          popup.style.right = 'auto';
        }
      }
    }
  },
  computed: {
    alignment() {
      if (this.$isDesktop() && !this.alignRight) {
        return "justify-content-center align-items-center";
      }
      return "align-items-right";
    }
  }
}
</script>
<style scoped>
/* .asmessage {
  border: 1px solid #bbbaba;
  border-radius: 20px;
  background: white;
  margin-left: 5px;
  display: inline-block;
  text-align: center;
  color: #171717;
  text-decoration: none;
  padding: 0 5px 0 5px;
} */

.innerpopup {
  z-index: 4000;
  background: white;
  position: absolute;
  right: 0;
  top: 25px;
  border: 1px solid #ccc;
  padding: 20px 20px;
}

@media (min-width: 1200px) {
  .cities_popup {
    width: max-content;
  }
}

@media (min-width: 768px) and (max-width:1200px) {
  .cities_popup {
    max-width: 50vw;
    right: -25px;
    width: 90vw;
    top: 20px;
  }
}

@media (max-width: 768px) {
  .cities_popup {
    max-width: 90vw;
    right: -25px;
    width: 90vw;
    top: 20px;
  }
}


.carousel .innerpopup {
  top: inherit;
  bottom: 25px;
}

.small-space {
  margin-left: 5px;
}
</style>